import React from "react";
import { FiX, FiBan, FiUser, FiCalendar, FiLoader } from "react-icons/fi";
import {BsBan} from "react-icons/bs";

const BreakModal = ({
                        open,
                        onClose,
                        staffList,
                        molaForm,
                        setMolaForm,
                        molaSlotsData,
                        molaSlotsLoading,
                        creating,
                        onSave,
                    }) => {
    if (!open) return null;

    return (
        <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-navy-900/70 backdrop-blur-md">
            <div
                className="bg-white dark:bg-navy-800 rounded-3xl shadow-2xl w-full max-w-2xl max-h-[90vh] flex flex-col overflow-hidden"
                style={{ animation: "scaleIn 0.2s ease-out" }}
            >
                {/* Header */}
                <div className="p-5 bg-red-50 dark:bg-red-900/10 border-b border-red-100 dark:border-red-800/30 flex justify-between items-center">
                    <div>
                        <h2 className="text-xl font-bold text-red-600 dark:text-red-400 flex items-center gap-2">
                            <BsBan /> Mola / Kapalı Slot Tanımla
                        </h2>
                        <p className="text-xs text-red-400 dark:text-red-500 mt-1">Seçilen saatler randevuya kapatılacak.</p>
                    </div>
                    <button
                        onClick={onClose}
                        className="p-2 rounded-xl text-gray-400 hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 transition-all"
                    >
                        <FiX size={22} />
                    </button>
                </div>

                {/* Body */}
                <div className="p-5 overflow-y-auto flex-1 space-y-5" style={{ scrollbarWidth: "thin" }}>
                    {/* Personel & Tarih */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-2">
                                <FiUser className="inline mr-1" /> Personel
                            </label>
                            <div className="relative">
                                <select
                                    value={molaForm.staffId}
                                    onChange={e => setMolaForm({ ...molaForm, staffId: e.target.value, selectedSlotIds: [] })}
                                    className="w-full appearance-none bg-white dark:bg-navy-900 border border-gray-200 dark:border-navy-600 rounded-xl px-4 py-3 text-sm text-navy-700 dark:text-white outline-none focus:border-brand-500 transition-all pr-10 cursor-pointer"
                                >
                                    <option value="all">Tüm Personeller</option>
                                    {staffList.map(s => (
                                        <option key={s.id} value={s.id}>
                                            {s.name} {s.surname}
                                        </option>
                                    ))}
                                </select>
                                <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400">▾</div>
                            </div>
                        </div>
                        <div>
                            <label className="block text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-2">
                                <FiCalendar className="inline mr-1" /> Tarih
                            </label>
                            <input
                                type="date"
                                value={molaForm.date}
                                onChange={e => setMolaForm({ ...molaForm, date: e.target.value, selectedSlotIds: [] })}
                                className="w-full bg-white dark:bg-navy-900 border border-gray-200 dark:border-navy-600 rounded-xl px-4 py-3 text-sm text-navy-700 dark:text-white outline-none focus:border-brand-500 transition-all"
                            />
                        </div>
                    </div>

                    {/* Saatler */}
                    <div>
                        <label className="block text-xs font-bold text-red-500 uppercase tracking-wide mb-3">
                            Kapatılacak Saatler
                        </label>
                        <div
                            className="bg-gray-50 dark:bg-navy-900 border border-gray-200 dark:border-navy-700 rounded-2xl p-4 min-h-[150px] max-h-[380px] overflow-y-auto"
                            style={{ scrollbarWidth: "thin" }}
                        >
                            {molaSlotsLoading ? (
                                <div className="flex items-center justify-center h-24 gap-3 text-gray-500">
                                    <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-brand-500"></div>
                                    <span className="text-sm">Saatler yükleniyor...</span>
                                </div>
                            ) : molaSlotsData.length === 0 ? (
                                <div className="flex flex-col items-center justify-center h-24 text-gray-400 dark:text-gray-600">
                                    <BsBan size={28} className="mb-2 opacity-40" />
                                    <span className="text-sm">Bu tarihte uygun slot bulunamadı.</span>
                                </div>
                            ) : (
                                <div className="space-y-5">
                                    {molaSlotsData.map((staffData, idx) => (
                                        <div key={idx}>
                                            <div className="flex items-center gap-2 mb-3">
                                                <div className="w-7 h-7 rounded-lg bg-brand-500/10 text-brand-600 dark:text-brand-400 flex items-center justify-center font-bold text-[10px]">
                                                    {((staffData.staff.name || "")[0] + (staffData.staff.surname || "")[0]).toUpperCase()}
                                                </div>
                                                <span className="text-sm font-bold text-navy-700 dark:text-white">
                          {staffData.staff.name} {staffData.staff.surname}
                        </span>
                                            </div>
                                            <div className="flex flex-wrap gap-2">
                                                {staffData.slots.map(slotObj => {
                                                    const timeStr = (slotObj.start_time || slotObj.time || "").substring(0, 5);
                                                    const isSelected = molaForm.selectedSlotIds.includes(slotObj.id);
                                                    return (
                                                        <button
                                                            key={slotObj.id}
                                                            type="button"
                                                            onClick={() => {
                                                                let newIds = [...molaForm.selectedSlotIds];
                                                                if (isSelected) {
                                                                    newIds = newIds.filter(id => id !== slotObj.id);
                                                                } else {
                                                                    newIds.push(slotObj.id);
                                                                }
                                                                setMolaForm({ ...molaForm, selectedSlotIds: newIds });
                                                            }}
                                                            className={`px-3 py-1.5 rounded-xl text-xs font-bold transition-all border
                                ${isSelected
                                                                ? "bg-red-500 text-white border-red-500 shadow-md shadow-red-500/20"
                                                                : "bg-white dark:bg-navy-800 text-gray-600 dark:text-gray-300 border-gray-200 dark:border-navy-600 hover:border-red-300 hover:text-red-500"}`}
                                                        >
                                                            {timeStr}
                                                        </button>
                                                    );
                                                })}
                                            </div>
                                            {idx < molaSlotsData.length - 1 && (
                                                <div className="mt-4 border-b border-gray-200 dark:border-navy-700"></div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        {molaForm.selectedSlotIds.length > 0 && (
                            <div className="mt-2 text-xs text-brand-500 font-bold flex items-center gap-1.5">
                                <div className="w-2 h-2 rounded-full bg-brand-500"></div>
                                Toplam {molaForm.selectedSlotIds.length} slot mola olarak işaretlenecek.
                            </div>
                        )}
                    </div>
                </div>

                {/* Footer */}
                <div className="p-4 bg-gray-50 dark:bg-navy-900 border-t border-gray-100 dark:border-navy-700 flex justify-end gap-3">
                    <button
                        type="button"
                        onClick={onClose}
                        className="px-5 py-2.5 rounded-xl text-sm font-bold text-gray-500 bg-white dark:bg-navy-800 border border-gray-200 dark:border-navy-600 hover:bg-gray-100 dark:hover:bg-navy-700 transition-all"
                    >
                        Vazgeç
                    </button>
                    <button
                        type="button"
                        onClick={onSave}
                        disabled={creating || molaForm.selectedSlotIds.length === 0}
                        className="flex items-center gap-2 px-6 py-2.5 rounded-xl text-sm font-bold text-white bg-red-500 hover:bg-red-600 shadow-lg shadow-red-500/20 transition-all disabled:opacity-50"
                    >
                        {creating ? (
                            <><div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div> Kaydediliyor...</>
                        ) : (
                            <><BsBan size={15}/> Seçili Saatleri Kapat</>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BreakModal;